import apiClient from "services/apiClient";

async function createDuplicateRole(data: any) {
  const url = `/admin/roles/duplicate-role`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default createDuplicateRole;
